import React, { useState } from 'react';
import { FaPlus } from 'react-icons/fa';

export default function FormularioProducto({ agregarProducto, margenDefecto = 25 }) {
    // Para Kokimiko solo necesitamos: Nombre, Costo Interno (Base)
    const [form, setForm] = useState({ producto: '', costoBase: '' });

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!form.producto || !form.costoBase) return;
        
        // Calculamos el precio de venta sugerido basado en el margen por defecto
        const costo = parseFloat(form.costoBase);
        const margenDecimal = parseFloat(margenDefecto) / 100;
        const precioSugerido = costo / (1 - margenDecimal);

        await agregarProducto({
            producto: form.producto,
            costoBase: costo,
            precioSugerido: parseFloat(precioSugerido.toFixed(2)),
            createdAt: new Date().toISOString()
        });
        
        setForm({ producto: '', costoBase: '' });
    };

    const inputStyle = "p-3 bg-white border border-gray-200 rounded-xl focus:ring-2 focus:ring-kokimiko-teal focus:outline-none text-sm font-bold text-kokimiko-texto w-full";

    return (
        <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-4">
            <div className="flex-1">
                <input 
                    required 
                    placeholder="Ej: Animador Hora Extra, Piñata Premium, Tarta..." 
                    className={inputStyle} 
                    value={form.producto} 
                    onChange={e => setForm({...form, producto: e.target.value})} 
                />
            </div>
            <div className="w-full sm:w-48">
                <input 
                    required 
                    type="number" 
                    step="0.01" 
                    min="0"
                    placeholder="Coste Interno (€)" 
                    className={inputStyle} 
                    value={form.costoBase} 
                    onChange={e => setForm({...form, costoBase: e.target.value})} 
                />
            </div>
            <div className="w-full sm:w-auto">
                <button type="submit" className="w-full h-full bg-kokimiko-teal text-white px-6 py-3 rounded-xl text-xs font-black hover:opacity-80 flex justify-center items-center gap-2 shadow-md uppercase tracking-widest">
                    <FaPlus /> Añadir
                </button>
            </div>
        </form>
    );
}